import type { DemoSourceType } from '../types';
import type { InstagramSourceValue } from './types';

// Отсутствие авторизации в источнике не препятствует разработке или отображению демо источника,
// но демо-авторизация предоставлена на всякий случай
/*
const previewInstagramAuth: DataServiceAuthValue = {
  data: {
    pid: '9a9a4b47-fc53-4fe5-a74c-41b05cb46662'
  },
  status: AuthStatus.Connected
};
*/

export const previewInstagramSources: DemoSourceType<InstagramSourceValue> = {
  'instagram-eat_for_pleasure': {
    label: 'Instagram: @eat_for_pleasure',
    source: {
      platform: 'instagram',
      connectionType: 'instagramAccount',
      id: 'kmc51jni',
      name: 'Instagram',
      showCarousel: true,
      showImage: true,
      showReels: true,
      showVideo: true,
      authentication: null,
      status: 'success',
      source: 'eat_for_pleasure',
      sourcePID: 'bb13818a-4126-4f84-b8ca-e5f7d41756de'
    }
  },
  instagram_instagood: {
    label: 'Instagram: #instagood',
    source: {
      platform: 'instagram',
      connectionType: 'instagramHashtag',
      id: 'kmc22tni',
      name: 'Instagram',
      showCarousel: true,
      showImage: true,
      showReels: true,
      showVideo: true,
      authentication: null,
      status: 'success',
      source: 'instagood',
      sourcePID: '14fd4e5f-d7f9-4cac-a7d8-344c007adca5'
    }
  },
  instagram_muradosmann: {
    label: 'Instagram: @muradosmann',
    source: {
      platform: 'instagram',
      connectionType: 'instagramMentions',
      id: 'kmc510ni',
      name: 'Instagram',
      showCarousel: true,
      showImage: true,
      showReels: true,
      showVideo: true,
      authentication: null,
      status: 'success',
      source: 'muradosmann',
      sourcePID: 'b7db94f0-093a-4f93-bc04-f417c7dfef3e'
    }
  }
};
